module.exports = __webpack_public_path__ + "img/business2.76346654.png";